import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import Lottie from "lottie-react";
import { CDN_LINK } from "@globalConfig";
import syarahLogoAnimation from "@/common/lottie/SyarahLogoblue.json";
var SyarahLogoLottie = function SyarahLogoLottie(_ref) {
  var width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? "syarah logo icon" : _ref$alt,
    id = _ref.id;
  var _useState = useState(false),
    isMounted = _useState[0],
    setIsMounted = _useState[1];
  useEffect(function () {
    setIsMounted(true);
  }, []);
  if (!isMounted) {
    return /*#__PURE__*/React.createElement("img", {
      width: width,
      height: height,
      className: className,
      src: CDN_LINK + "/assets/images/logoN.svg",
      alt: alt,
      id: id
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: width,
      height: height
    },
    className: className,
    id: id
  }, /*#__PURE__*/React.createElement(Lottie, {
    animationData: syarahLogoAnimation,
    loop: true,
    style: {
      width: "100%",
      height: "100%"
    }
  }));
};
export default SyarahLogoLottie;